import { isDateBetween } from './utils';
import { AskRequest, ReportTypes } from '@hone-automation/common';

/**
 * Filters queue issues (flagged cells and ask requests) for the given report.
 *
 * Uses AskRequest format directly from the backend without intermediate conversions.
 * Filters out deleted items and applies date range filtering for P&L Comparison reports.
 *
 * @param report - The report containing date ranges and type information
 * @param queueIssues - Array of AskRequest from the backend
 * @returns Filtered array of AskRequest
 */
export const filterFlaggedIssues = (report: NestedHoneReport, queueIssues?: AskRequest[]): AskRequest[] => {
  if (!report || !queueIssues || queueIssues.length === 0) {
    return [];
  }

  // Filter out deleted items and items without valid types
  const activeIssues = queueIssues.filter(issue => {
    const issueType = issue.type;
    const isValidType = issueType === 'Flagged Cell' || issueType === 'Ask Bookkeeper' || !issueType;
    return isValidType && !issue.deleted;
  });

  // For non-P&L Comparison reports, return all active issues
  if (report.type !== ReportTypes.PLComparison) {
    return activeIssues;
  }

  // For P&L Comparison, filter by date range
  return activeIssues.filter(issue => {
    // Get the relevant date for matching (period or transaction date)
    const issuePeriod = issue.transaction?.date ? issue.transaction.date.split('T')[0] : issue.period;

    return report.dates.some((date: { start: string; end: string }) => {
      return isDateBetween(date.start, date.end, issuePeriod);
    });
  });
};
